import * as React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { styled } from "@mui/material/styles";
import {
  Box,
  Button,
  CardContent,
  Card,
  Paper,
  CardMedia,
  Stack,
  Typography,
} from "@mui/material";
import { imageCarousalSettings } from "../Data/carousal";

const MuiTitle = styled(Typography)(() => ({
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 1,
  fontWeight: 600,
}));

const MuiText = styled(Typography)(() => ({
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 2,
}));

const GallerySubHome = ({ data, setModalOpen }) => {
  let navigate = useNavigate();
  let handleClick = (data) => {
    navigate(data);
  };

  return (
    <>
      <Box>
        <Stack
          direction="row"
          sx={{
            zIndex: 50,
            position: "relative",
            bottom: "-20px",
            left: "10px",
            gap: "10px",
          }}
        >
          {/* {data.title && (
            <Paper
              variant="contained"
              size="small"
              onClick={() => handleClick(data.path1)}
              sx={{
                bgcolor: "#ff4500",
                color: "white",
                padding: "8px",
              }}
            >
              {data.title}
            </Paper>
          )} */}
          {data.role2 && (
            <Button
              variant="contained"
              size="small"
              onClick={() => handleClick(data.path2)}
              sx={{
                bgcolor: "#1779f7",
                color: "white",
                border: "solid #1779f7",
                // bgcolor: "#f55214",
                "&:hover": {
                  color: "white",
                  bgcolor: "#ff4500",
                  border: "solid #ff4500",
                },
              }}
            >
              {data.role2}
            </Button>
          )}
        </Stack>
        <Card>
          <Slider
            lazyLoad="progressive"
            dots
            sx={{ backgroundColor: "black" }}
            {...imageCarousalSettings}
          >
            {data.images?.map((image, index) => {
              if (image.type == "image") {
                return (
                  <CardMedia
                    key={index}
                    component="img"
                    image={image.link}
                    alt="loading..."
                    height="360"
                    onClick={() =>
                      setModalOpen({
                        open: true,
                        imageData: data.images,
                        viewSingleImg: image,
                      })
                    }
                  />
                )
              }
              if (image.type == "youtube" || image.type == "youtubeshorts") {
                return (
                  <iframe
                    key={index}
                    // width="300"
                    height="360"
                    src={image.link}
                    title="YouTube video player"
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                )
              }
              // if (image.type == "youtubeshorts") {
              //   return (
              //     <iframe
              //       key={index}
              //       // width="300"
              //       height="660"
              //       src={image.link}
              //       title="YouTube video player"
              //       allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              //       allowFullScreen
              //     ></iframe>
              //   )
              // }
            })}
          </Slider>

          {data.title && (
            <CardContent sx={{ mt: 1, height: "110px" }}>
              <MuiTitle
                gutterBottom
                variant="h5"
                component="div"
                sx={{ color: "#F86F03" }}
              >
                {data.title}
              </MuiTitle>
              <MuiText variant="body2" color="text.secondary">
                {data.note || "Added new images"}
              </MuiText>
            </CardContent>
          )}        </Card>
      </Box>
    </>
  );
};

export default GallerySubHome;
